import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle, XCircle } from "@phosphor-icons/react";
import { Logo } from "../components/Logo";
import { api } from "../lib/api";

export default function Confirm() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState("loading"); // loading | ok | error
  const [name, setName] = useState("");

  useEffect(() => {
    api
      .get(`/referrals/confirm/${token}`)
      .then(({ data }) => {
        setName(data.kontakt_name || "");
        setState("ok");
      })
      .catch(() => setState("error"));
  }, [token]);

  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col bg-[#0A1128]">
      <div className="px-7 pt-8">
        <Logo light />
      </div>
      <div className="flex flex-1 flex-col items-center justify-center px-8 text-center">
        {state === "loading" && <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#C5A059] border-t-transparent" />}
        {state === "ok" && (
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} data-testid="confirm-success">
            <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-[#C5A059]/15">
              <CheckCircle size={44} weight="fill" color="#C5A059" />
            </div>
            <h1 className="mt-8 font-display text-4xl font-light tracking-tight text-white">Vielen Dank!</h1>
            <p className="mt-4 text-base leading-relaxed text-white/70">
              Deine Zustimmung ist bestätigt{name ? ` – ${name}` : ""}. Ein Berater wird sich in Kürze diskret bei dir melden.
            </p>
          </motion.div>
        )}
        {state === "error" && (
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} data-testid="confirm-error">
            <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-white/5">
              <XCircle size={44} weight="fill" color="#DD6B20" />
            </div>
            <h1 className="mt-8 font-display text-4xl font-light tracking-tight text-white">Link ungültig</h1>
            <p className="mt-4 text-base text-white/70">Dieser Bestätigungslink ist nicht mehr gültig oder wurde bereits verwendet.</p>
          </motion.div>
        )}
        <button onClick={() => navigate("/")} className="mt-10 rounded-full border border-white/20 px-6 py-3 text-sm text-white/70 transition-colors hover:text-white">
          Zur Startseite
        </button>
      </div>
    </div>
  );
}
